<template>
    <div class="header flex-between-center">
        <div class="header-wrapper">
            <div class="title-tab-question-wrapper">
                <div class="extension-icon" :style="[(activeContent.headers.icon_type == 'fontawesome')?{'font-size':'none'}:{'font-size': '0'}]">
                    <i v-if="(activeContent.headers.icon_type == 'fontawesome')" :class="['fas',activeContent.headers.icon]"></i>
                    <svg v-if="(activeContent.headers.icon_type == 'svg')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.75 130.05">
                        <use :xlink:href="activeContent.headers.icon"></use>
                    </svg>
                </div>
                <div class="title-tab-question">
                    <h2>{{activeContent.headers.title}}</h2>
                    <p>{{activeContent.headers.description}}</p>
                </div>
            </div>
            <div class="more-info-question-wrapper" v-if="activeContent.headers.questionTooltip.length != 0">
                <div class="question-char">
                    <span>?</span>
                </div>
                <div class="question-tooltip">
                    <p>
                        {{activeContent.headers.questionTooltip}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['activeContent'],
        name: "Sub"
    }
</script>

<style scoped>
    .header.flex-between-center {
        height: 132px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header.flex-between-center .header-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        color: white;
    }

    .title-tab-question-wrapper .extension-icon {
        width: 60px;
        --main-svg-color: #fff;
        --secondary-svg-color: #fff;
        margin-right: 20px;
    }

    .extension-icon {
        width: 40px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        transition: all .3s;
    }

    .title-tab-question {
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 0;
        width: calc(100% - 80px);
    }

    .title-tab-question h2 {
        margin-bottom: 5px;
    }

    .title-tab-question p {
        font-size: 14px;
        color: #fff;
    }

    h2 {
        font-size: 30px;
        text-transform: uppercase;
        color: #fff;
        margin-bottom: 20px;
    }


    .header.flex-between-center {
        height: 132px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header.flex-between-center .header-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .header-wrapper {
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        transition: all .5s;
    }
</style>